import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PortfolioValuationSummary } from '../../Models/Domains/Valuation/PortfolioValuationSummary';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';
import { PerformanceMethod } from '../../Models/Models/Transformation/Performance/PerformanceMethod';
import { IJsonDate } from '../../System/IJsonDate';
import { DateFromType } from '../../Constants/Enums/Domain/Transformation/Valuation/DateFromType';

declare var IS_RUNNING_IN_APP_POOL;

export class NewPortfolioValuationSummaryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(headAccountHierarchyIds: Array<string>, subAccountHierarchyIds: Array<string>, assetClassType: AssetClassType, performanceMethod: PerformanceMethod, asAt: IJsonDate, dateFromType: DateFromType): Promise<PortfolioValuationSummary, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transformation/NewPortfolioValuationSummary/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { headAccountHierarchyIds: headAccountHierarchyIds, subAccountHierarchyIds: subAccountHierarchyIds, assetClassType: assetClassType, performanceMethod: performanceMethod, asAt: asAt, dateFromType: dateFromType }

    return AjaxWrapper.post<PortfolioValuationSummary, any>(url, data);
  }
}

